/* flow */

export const buttonReset = `
  border-width: 0;
  border-radius: 0;
  background: transparent;
  padding: 0;
  outline: 0;
`
